// ============================================================
// nomeDeArquivo.js — como o núcleo entra no nome do arquivo
//
// O relatório sai do portal e vai para um anexo de e-mail. O que estava
// escrito ali era a CHAVE do núcleo — "Relatorio_IFCE_Setembro_2026.pdf" —,
// e IFCE é identificador de banco: quem recebe conhece o núcleo por
// "CFO - Ceará".
//
// Passa a sair do NOME de cadastro, sem acento e sem espaço, porque nome de
// arquivo atravessa e-mail, Windows, Drive e WhatsApp, e cada um estraga um
// caractere diferente. "CFO - Ceará" vira "CFO-Ceara".
//
// A consequência, que é intencional: renomear o núcleo no cadastro muda o
// nome dos relatórios seguintes. Os já baixados não mudam. Foi a escolha da
// coordenação — vale mais o arquivo dizer o nome que as pessoas usam do que
// o nome ser estável para sempre.
//
// Núcleo novo não precisa de nada: o nome do cadastro dele já entra aqui.
// Sem nome cadastrado, cai na chave, que é melhor do que arquivo sem dono.
// ============================================================

const DIACRITICOS = new RegExp(
  "[" + String.fromCharCode(0x300) + "-" + String.fromCharCode(0x36f) + "]",
  "g"
);

export function nucleoParaArquivo(nucleoNome, nucleo) {
  const bruto = String(nucleoNome || nucleo || "").trim();
  const limpo = bruto
    .normalize("NFD").replace(DIACRITICOS, "")   // Ceará -> Ceara
    // Sublinhado fica: identificador como RT_BAHIA já é nome de arquivo
    // válido, e trocá-lo por traço só desfiguraria o que estava certo.
    .replace(/[^A-Za-z0-9_]+/g, "-")             // espaço, ponto e traço viram um traço
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
  return limpo || String(nucleo || "nucleo");
}
